import React, { Children, FC, isValidElement } from 'react';
import { QueryResult } from 'react-apollo';
import { NetworkStatus } from 'apollo-client';

import { LoaderTypes } from 'types/app';
import { Error, Loaders, NullComponent } from './';

interface IProps extends QueryResult {
  children: (props: IProps) => any;
  loader?: LoaderTypes;
}

const QueryManager: FC<IProps> = props => {
  const { loading, loader, error, networkStatus, children } = props;
  const LoaderComponent = getLoader();

  function getLoader() {
    switch (loader) {
      case 'standard':
        return Loaders.Standard;
      case 'widget':
        return Loaders.Widget;
      case 'none':
        return NullComponent;
      default:
        return Loaders.Standard;
    }
  }

  if (networkStatus === NetworkStatus.fetchMore) {
    return children(props);
  }

  if (loading) {
    return isValidElement(loader) ? loader : <LoaderComponent {...props} />;
  }

  if (error) {
    return Children.toArray(children(props)).concat(<Error key="error" message={error} />);
  }

  return children(props);
};

QueryManager.defaultProps = {
  loader: 'standard',
};

export default QueryManager;
